import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SectionTitle = styled.span`
  display: block;
  margin: 1rem 0 0.5rem;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${tokens.text.muted};
`

export const CategoryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.glass};
`

export const CategoryInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const CategoryName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const CategoryHint = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const AlwaysOnList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.25rem;
`

export const AlwaysOnChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: ${tokens.radius.chip};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.inset};
  font-size: ${tokens.font.micro};
  color: ${tokens.text.secondary};
`

export const HelperNote = styled.span`
  display: block;
  margin-top: 0.5rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const CategoryBlock = styled.div<{ $dim?: boolean }>`
  display: flex;
  flex-direction: column;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.glass};
  opacity: ${({ $dim }) => ($dim ? 0.55 : 1)};
`

export const CategoryHead = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  user-select: none;

  &:hover {
    background: ${({ $clickable }) => ($clickable ? tokens.surface.inset : 'transparent')};
  }
`

export const HeadChevron = styled.span<{ $open: boolean }>`
  flex: none;
  display: inline-block;
  color: ${tokens.text.muted};
  font-size: 0.875rem;
  transform: rotate(${({ $open }) => ($open ? '90deg' : '0deg')});
  transition: transform ${tokens.motion.duration} ${tokens.motion.ease};
`

export const TypeList = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${tokens.border.hairline};
  padding: 0.25rem 1rem 0.5rem 2.25rem;
`

export const TypeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.375rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }
`

export const TypeName = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const PendingTag = styled.span`
  font-size: ${tokens.font.micro};
  font-style: italic;
  white-space: nowrap;
  color: ${tokens.text.muted};
  cursor: help;
`

export const LockTag = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 600;
  white-space: nowrap;
  color: ${tokens.accent.base};
`

export const OffNote = styled.span`
  padding: 0 1rem 0.75rem 2.25rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`
